/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Scrolltop_AriaInputs */

const en_scrolltop_aria = /** @type {(inputs: Scrolltop_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Scroll to top`)
};

const pt_scrolltop_aria = /** @type {(inputs: Scrolltop_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Voltar ao topo`)
};

const es_scrolltop_aria = /** @type {(inputs: Scrolltop_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Volver arriba`)
};

/**
* | output |
* | --- |
* | "Scroll to top" |
*
* @param {Scrolltop_AriaInputs} inputs
* @param {{ locale?: "en" | "pt" | "es" }} options
* @returns {LocalizedString}
*/
export const scrolltop_aria = /** @type {((inputs?: Scrolltop_AriaInputs, options?: { locale?: "en" | "pt" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Scrolltop_AriaInputs, { locale?: "en" | "pt" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt") return pt_scrolltop_aria(inputs)
	if (locale === "es") return es_scrolltop_aria(inputs)
	return en_scrolltop_aria(inputs)
});